import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditIncomingAuth = mutatorAction('updateEditIncomingAuth', function (incomingAuth) {
    var store = connectedAccountsStore();
    store.editAccountState.incomingAuth = incomingAuth;
});
//# sourceMappingURL=updateEditIncomingAuth.js.map